module.exports = __webpack_public_path__ + "img/483.b40c9808.png";